import { useState, useMemo } from "react";

export function useColumnFilter(sourceData, columnKey) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedValues, setSelectedValues] = useState([]);

  const uniqueValues = useMemo(
    () => [
      ...new Set(
        sourceData
          .map((r) => r[columnKey])
          .filter((v) => v !== null && v !== undefined && v !== ""),
      ),
    ],
    [sourceData, columnKey],
  );

  const openFilter = (e) => setAnchorEl(e.currentTarget);
  const closeFilter = () => setAnchorEl(null);
  const toggleValue = (v) =>
    setSelectedValues((prev) =>
      prev.includes(v) ? prev.filter((x) => x !== v) : [...prev, v],
    );
  const clearFilter = () => setSelectedValues([]);

  const matches = (row) =>
    selectedValues.length === 0 || selectedValues.includes(row[columnKey]);

  return {
    anchorEl,
    selectedValues,
    uniqueValues,
    openFilter,
    closeFilter,
    toggleValue,
    clearFilter,
    matches,
  };
}